import './Reviews.css';
import React, {useEffect, useState} from 'react';
import {decode} from 'html-entities';
import {axiosInstance, eventEmitter} from '../../../common/baseData';
import ProductItem from './productItem/ProductItem';
import ProductReview from './productReview/ProductReview';

function Reviews(props) {
  const [state, setState] = useState({
    products: props.products || [],
    category: props.category || {},
    messages: props.messages || {},
    user: {},
    allUrl: false,
    asyncUrl: props.asyncUrl || '',
    sectionId: props.sectionId || 0,
    limit: Number(props.limit) || 10,
    nextOffset: Number(props.nextOffset) || (props.products ? props.products.length : 0),
    hasMore: Boolean(props.hasMore),
    loading: false,
  });

  useEffect(() => {
    setState(prevState => ({
      ...prevState,
      products: props.products || [],
      category: props.category || {},
      messages: props.messages || {},
      asyncUrl: props.asyncUrl || '',
      sectionId: props.sectionId || 0,
      limit: Number(props.limit) || 10,
      nextOffset: Number(props.nextOffset) || (props.products ? props.products.length : 0),
      hasMore: Boolean(props.hasMore),
      loading: false,
    }));
  }, [
    props.products,
    props.category,
    props.messages,
    props.asyncUrl,
    props.sectionId,
    props.limit,
    props.nextOffset,
    props.hasMore,
  ]);

  function getMessage(code) {
    return state.hasOwnProperty('messages') &&
    state.messages.hasOwnProperty(code) ?
        state.messages[code] : `lang message: ${code} not defined`;
  }

  async function onShowMore() {
    if (!state.asyncUrl || state.loading || !state.hasMore) {
      return;
    }

    setState(prevState => ({
      ...prevState,
      loading: true,
    }));

    eventEmitter.emit('showLoader');

    try {
      const response = await axiosInstance.post(state.asyncUrl, {
        sectionId: state.sectionId,
        limit: state.limit,
        offset: state.nextOffset,
      });

      const data = response?.data || {};

      setState(prevState => ({
        ...prevState,
        products: prevState.products.concat(Array.isArray(data.products) ? data.products : []),
        category: data.category && Object.keys(data.category).length ? data.category : prevState.category,
        nextOffset: Number(data.nextOffset) || prevState.nextOffset,
        hasMore: Boolean(data.hasMore),
        loading: false,
      }));
    } catch (error) {
      console.error(error);
      setState(prevState => ({
        ...prevState,
        loading: false,
      }));
    } finally {
      eventEmitter.emit('hideLoader');
    }
  }

  return (
      <section id={'category-reviews'}>
        {
          state.category.URL !== false && state.products.length > 0 ?
            <div className="reviews-bottom-link">
              <a href={`${state.category.URL}/reviews/`}>
                {state.category.NAME}{getMessage('REVIEWS_LINK_TITLE')}
              </a>
            </div> :
            <></>
        }
        {
          state.products.map((product, index) => {
            return <div className={`product-reviews-block`}
                        key={product.XML_ID}>
              <ProductItem {...product} getMessage={getMessage}></ProductItem>
              <div className={`reviews-item`}>
                <div className={`section-item-text`}>
                  {getMessage('PRODUCT_COMMENTS')}&nbsp;{decode(product.NAME)}
                </div>
                <div className={`testimonials-block`}>
                  <div className={`testimonials-body`}>
                    {
                      product.hasOwnProperty('REVIEWS') &&
                      product.REVIEWS.length ?
                          product.REVIEWS.map((review, key) => {
                            return <ProductReview
                                {...review}
                                currentUser={state.user}
                                productId={product.ID}
                                getMessage={getMessage}
                                key={key}/>;
                          }) :
                          <></>
                    }
                  </div>
                </div>
              </div>
            </div>;
          })
        }
        {
          state.hasMore ?
            <div className="show-more"
                 onClick={onShowMore}>
              <i className="icon-showing-more"></i>
              <span>{getMessage('SHOW_MORE')}</span>
            </div> :
            <></>
        }
      </section>
  );
}

export default Reviews;